<template>
  <div>
    <div v-if="usedCells.length > 0">
      <v-card flat>
        <v-card-text class="py-0 text-subtitle-1">
          Использование ячеек
        </v-card-text>

        <v-card-text class="pt-2">
          <v-row justify="start">
            <v-col v-for="cells in usedCells" :key="cells.cargoTypeId" class="pt-0" cols="12" sm="6" md="4" lg="3"
              xl="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-card flat class="tableHeader px-4 py-2" v-bind="attrs" v-on="on">
                    <v-row no-gutters>
                      <span>{{ cells.cargoTypeName }}</span>
                      <v-spacer />
                      <div>
                        <span>{{ cells.warehouse + cells.unloading }}</span>
                        <span v-if="cells.cellsLimit" class="pl-1">из {{ cells.cellsLimit }}</span>
                      </div>
                    </v-row>
                  </v-card>
                </template>
                <div>
                  <div>На складе: {{ cells.warehouse }}</div>
                  <div>В Зоне разгрузки: {{ cells.unloading }}</div>
                </div>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cargoTypeId: { type: Number, default: 0 }
  },

  data: () => ({
    usedCells: [],
    timer: Object
  }),

  watch: {
    cargoTypeId() {
      this.refresh()
    }
  },

  created() {
    this.refresh()
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },

  methods: {
    async refresh() {
      try {
        const response = await this.axios.get(`/carRequests/usedCellsCount/${this.cargoTypeId}`)
        this.usedCells = response.data
      } catch (err) {
        this.usedCells = []
      }

      this.resetTimer()
    },

    resetTimer() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.refresh(), 1000 * 60)
    }
  }
}
</script>
